export default function CountryCode() {
  return (
    <>
      <select
        style={{
          width: "35%",
          padding: "1% 1%",
          borderRadius: "5px",
          height: "30px",
          outline: "1px solid #3498db",
          border: "none",
          color: "#3498db",
        }}
        id="oneLinePhoneNumberCountryCodeHiddenSelect"
        class="cko-field country-code gb-whitelist"
        data-normalize="false"
        name="tripPreferencesRequest.hotelTripPreferences.hotelRoomPreferences[0].preferredPhoneCountryCode"
        data-rfrr-validation-error="hotel.pref[0].preferredPhoneCountryCode"
        data-cko-blur="trackOmniture"
        data-cko-rfrr-id="HOT.CKO.PHONECOUNTRYCODE"
        data-lpignore="true"
        aria-label="Country/Territory Code"
        data-cko-enter-click="submitForm"
        data-cko-change="setEditedFieldState"
      >
        <option
          value="93"
          data-country-iso="afg"
          data-country-name="Afghanistan"
          data-one-line-phone-number="AFG +93"
        >
          Afghanistan +93
        </option>
        <option
          value="355"
          data-country-iso="alb"
          data-country-name="Albania"
          data-one-line-phone-number="ALB +355"
        >
          Albania +355
        </option>
        <option
          value="213"
          data-country-iso="dza"
          data-country-name="Algeria"
          data-one-line-phone-number="DZA +213"
        >
          Algeria +213
        </option>
        <option
          value="1"
          data-country-iso="asm"
          data-country-name="American Samoa"
          data-one-line-phone-number="ASM +1"
        >
          American Samoa +1
        </option>
        <option
          value="376"
          data-country-iso="and"
          data-country-name="Andorra"
          data-one-line-phone-number="AND +376"
        >
          Andorra +376
        </option>
        <option
          value="244"
          data-country-iso="ago"
          data-country-name="Angola"
          data-one-line-phone-number="AGO +244"
        >
          Angola +244
        </option>
        <option
          value="1"
          data-country-iso="aia"
          data-country-name="Anguilla"
          data-one-line-phone-number="AIA +1"
        >
          Anguilla +1
        </option>
        <option
          value="672"
          data-country-iso="ata"
          data-country-name="Antarctica"
          data-one-line-phone-number="ATA +672"
        >
          Antarctica +672
        </option>
        <option
          value="1"
          data-country-iso="atg"
          data-country-name="Antigua and Barbuda"
          data-one-line-phone-number="ATG +1"
        >
          Antigua and Barbuda +1
        </option>
        <option
          value="54"
          data-country-iso="arg"
          data-country-name="Argentina"
          data-one-line-phone-number="ARG +54"
        >
          Argentina +54
        </option>
        <option
          value="374"
          data-country-iso="arm"
          data-country-name="Armenia"
          data-one-line-phone-number="ARM +374"
        >
          Armenia +374
        </option>
        <option
          value="297"
          data-country-iso="abw"
          data-country-name="Aruba"
          data-one-line-phone-number="ABW +297"
        >
          Aruba +297
        </option>
        <option
          value="61"
          data-country-iso="aus"
          data-country-name="Australia"
          data-one-line-phone-number="AUS +61"
        >
          Australia +61
        </option>
        <option
          value="43"
          data-country-iso="aut"
          data-country-name="Austria"
          data-one-line-phone-number="AUT +43"
        >
          Austria +43
        </option>
        <option
          value="994"
          data-country-iso="aze"
          data-country-name="Azerbaijan"
          data-one-line-phone-number="AZE +994"
        >
          Azerbaijan +994
        </option>
        <option
          value="1"
          data-country-iso="bhs"
          data-country-name="Bahamas"
          data-one-line-phone-number="BHS +1"
        >
          Bahamas +1
        </option>
        <option
          value="973"
          data-country-iso="bhr"
          data-country-name="Bahrain"
          data-one-line-phone-number="BHR +973"
        >
          Bahrain +973
        </option>
        <option
          value="880"
          data-country-iso="bgd"
          data-country-name="Bangladesh"
          data-one-line-phone-number="BGD +880"
        >
          Bangladesh +880
        </option>
        <option
          value="1"
          data-country-iso="brb"
          data-country-name="Barbados"
          data-one-line-phone-number="BRB +1"
        >
          Barbados +1
        </option>
        <option
          value="375"
          data-country-iso="blr"
          data-country-name="Belarus"
          data-one-line-phone-number="BLR +375"
        >
          Belarus +375
        </option>
        <option
          value="32"
          data-country-iso="bel"
          data-country-name="Belgium"
          data-one-line-phone-number="BEL +32"
        >
          Belgium +32
        </option>
        <option
          value="501"
          data-country-iso="blz"
          data-country-name="Belize"
          data-one-line-phone-number="BLZ +501"
        >
          Belize +501
        </option>
        <option
          value="229"
          data-country-iso="ben"
          data-country-name="Benin"
          data-one-line-phone-number="BEN +229"
        >
          Benin +229
        </option>
        <option
          value="1"
          data-country-iso="bmu"
          data-country-name="Bermuda"
          data-one-line-phone-number="BMU +1"
        >
          Bermuda +1
        </option>
        <option
          value="975"
          data-country-iso="btn"
          data-country-name="Bhutan"
          data-one-line-phone-number="BTN +975"
        >
          Bhutan +975
        </option>
        <option
          value="591"
          data-country-iso="bol"
          data-country-name="Bolivia"
          data-one-line-phone-number="BOL +591"
        >
          Bolivia +591
        </option>
        <option
          value="387"
          data-country-iso="bih"
          data-country-name="Bosnia and Herzegovina"
          data-one-line-phone-number="BIH +387"
        >
          Bosnia and Herzegovina +387
        </option>
        <option
          value="267"
          data-country-iso="bwa"
          data-country-name="Botswana"
          data-one-line-phone-number="BWA +267"
        >
          Botswana +267
        </option>
        <option
          value="55"
          data-country-iso="bra"
          data-country-name="Brazil"
          data-one-line-phone-number="BRA +55"
        >
          Brazil +55
        </option>
        <option
          value="1"
          data-country-iso="vgb"
          data-country-name="British Virgin Islands"
          data-one-line-phone-number="VGB +1"
        >
          British Virgin Islands +1
        </option>
        <option
          value="673"
          data-country-iso="brn"
          data-country-name="Brunei"
          data-one-line-phone-number="BRN +673"
        >
          Brunei +673
        </option>
        <option
          value="359"
          data-country-iso="bgr"
          data-country-name="Bulgaria"
          data-one-line-phone-number="BGR +359"
        >
          Bulgaria +359
        </option>
        <option
          value="226"
          data-country-iso="bfa"
          data-country-name="Burkina Faso"
          data-one-line-phone-number="BFA +226"
        >
          Burkina Faso +226
        </option>
        <option
          value="257"
          data-country-iso="bdi"
          data-country-name="Burundi"
          data-one-line-phone-number="BDI +257"
        >
          Burundi +257
        </option>
        <option
          value="855"
          data-country-iso="khm"
          data-country-name="Cambodia"
          data-one-line-phone-number="KHM +855"
        >
          Cambodia +855
        </option>
        <option
          value="237"
          data-country-iso="cmr"
          data-country-name="Cameroon"
          data-one-line-phone-number="CMR +237"
        >
          Cameroon +237
        </option>
        <option
          value="1"
          data-country-iso="can"
          data-country-name="Canada"
          data-one-line-phone-number="CAN +1"
        >
          Canada +1
        </option>
        <option
          value="238"
          data-country-iso="cpv"
          data-country-name="Cape Verde"
          data-one-line-phone-number="CPV +238"
        >
          Cape Verde +238
        </option>
        <option
          value="1"
          data-country-iso="cym"
          data-country-name="Cayman Islands"
          data-one-line-phone-number="CYM +1"
        >
          Cayman Islands +1
        </option>
        <option
          value="236"
          data-country-iso="caf"
          data-country-name="Central African Republic"
          data-one-line-phone-number="CAF +236"
        >
          Central African Republic +236
        </option>
        <option
          value="235"
          data-country-iso="tcd"
          data-country-name="Chad"
          data-one-line-phone-number="TCD +235"
        >
          Chad +235
        </option>
        <option
          value="56"
          data-country-iso="chl"
          data-country-name="Chile"
          data-one-line-phone-number="CHL +56"
        >
          Chile +56
        </option>
        <option
          value="86"
          data-country-iso="chn"
          data-country-name="China"
          data-one-line-phone-number="CHN +86"
        >
          China +86
        </option>
        <option
          value="61"
          data-country-iso="cxr"
          data-country-name="Christmas Island"
          data-one-line-phone-number="CXR +61"
        >
          Christmas Island +61
        </option>
        <option
          value="61"
          data-country-iso="cck"
          data-country-name="Cocos Islands"
          data-one-line-phone-number="CCK +61"
        >
          Cocos Islands +61
        </option>
        <option
          value="57"
          data-country-iso="col"
          data-country-name="Colombia"
          data-one-line-phone-number="COL +57"
        >
          Colombia +57
        </option>
        <option
          value="269"
          data-country-iso="com"
          data-country-name="Comoros"
          data-one-line-phone-number="COM +269"
        >
          Comoros +269
        </option>
        <option
          value="682"
          data-country-iso="cok"
          data-country-name="Cook Islands"
          data-one-line-phone-number="COK +682"
        >
          Cook Islands +682
        </option>
        <option
          value="506"
          data-country-iso="cri"
          data-country-name="Costa Rica"
          data-one-line-phone-number="CRI +506"
        >
          Costa Rica +506
        </option>
        <option
          value="385"
          data-country-iso="hrv"
          data-country-name="Croatia"
          data-one-line-phone-number="HRV +385"
        >
          Croatia +385
        </option>
        <option
          value="53"
          data-country-iso="cub"
          data-country-name="Cuba"
          data-one-line-phone-number="CUB +53"
        >
          Cuba +53
        </option>
        <option
          value="599"
          data-country-iso="cuw"
          data-country-name="Curacao"
          data-one-line-phone-number="CUW +599"
        >
          Curacao +599
        </option>
        <option
          value="357"
          data-country-iso="cyp"
          data-country-name="Cyprus"
          data-one-line-phone-number="CYP +357"
        >
          Cyprus +357
        </option>
        <option
          value="420"
          data-country-iso="cze"
          data-country-name="Czech Republic"
          data-one-line-phone-number="CZE +420"
        >
          Czech Republic +420
        </option>
        <option
          value="225"
          data-country-iso="civ"
          data-country-name="Côte d'Ivoire"
          data-one-line-phone-number="CIV +225"
        >
          Côte d'Ivoire +225
        </option>
        <option
          value="243"
          data-country-iso="cod"
          data-country-name="Democratic Republic of the Congo"
          data-one-line-phone-number="COD +243"
        >
          Democratic Republic of the Congo +243
        </option>
        <option
          value="45"
          data-country-iso="dnk"
          data-country-name="Denmark"
          data-one-line-phone-number="DNK +45"
        >
          Denmark +45
        </option>
        <option
          value="253"
          data-country-iso="dji"
          data-country-name="Djibouti"
          data-one-line-phone-number="DJI +253"
        >
          Djibouti +253
        </option>
        <option
          value="1"
          data-country-iso="dma"
          data-country-name="Dominica"
          data-one-line-phone-number="DMA +1"
        >
          Dominica +1
        </option>
        <option
          value="1"
          data-country-iso="dom"
          data-country-name="Dominican Republic"
          data-one-line-phone-number="DOM +1"
        >
          Dominican Republic +1
        </option>
        <option
          value="593"
          data-country-iso="ecu"
          data-country-name="Ecuador"
          data-one-line-phone-number="ECU +593"
        >
          Ecuador +593
        </option>
        <option
          value="20"
          data-country-iso="egy"
          data-country-name="Egypt"
          data-one-line-phone-number="EGY +20"
        >
          Egypt +20
        </option>
        <option
          value="503"
          data-country-iso="slv"
          data-country-name="El Salvador"
          data-one-line-phone-number="SLV +503"
        >
          El Salvador +503
        </option>
        <option
          value="224"
          data-country-iso="gnq"
          data-country-name="Equatorial Guinea"
          data-one-line-phone-number="GNQ +224"
        >
          Equatorial Guinea +224
        </option>
        <option
          value="291"
          data-country-iso="eri"
          data-country-name="Eritrea"
          data-one-line-phone-number="ERI +291"
        >
          Eritrea +291
        </option>
        <option
          value="372"
          data-country-iso="est"
          data-country-name="Estonia"
          data-one-line-phone-number="EST +372"
        >
          Estonia +372
        </option>
        <option
          value="268"
          data-country-iso="swz"
          data-country-name="Eswatini"
          data-one-line-phone-number="SWZ +268"
        >
          Eswatini +268
        </option>
        <option
          value="251"
          data-country-iso="eth"
          data-country-name="Ethiopia"
          data-one-line-phone-number="ETH +251"
        >
          Ethiopia +251
        </option>
        <option
          value="500"
          data-country-iso="flk"
          data-country-name="Falkland Islands"
          data-one-line-phone-number="FLK +500"
        >
          Falkland Islands +500
        </option>
        <option
          value="298"
          data-country-iso="fro"
          data-country-name="Faroe Islands"
          data-one-line-phone-number="FRO +298"
        >
          Faroe Islands +298
        </option>
        <option
          value="252"
          data-country-iso="som"
          data-country-name="Federal Republic of Somalia"
          data-one-line-phone-number="SOM +252"
        >
          Federal Republic of Somalia +252
        </option>
        <option
          value="691"
          data-country-iso="fsm"
          data-country-name="Federated States of Micronesia"
          data-one-line-phone-number="FSM +691"
        >
          Federated States of Micronesia +691
        </option>
        <option
          value="679"
          data-country-iso="fji"
          data-country-name="Fiji"
          data-one-line-phone-number="FJI +679"
        >
          Fiji +679
        </option>
        <option
          value="358"
          data-country-iso="fin"
          data-country-name="Finland"
          data-one-line-phone-number="FIN +358"
        >
          Finland +358
        </option>
        <option
          value="33"
          data-country-iso="fra"
          data-country-name="France"
          data-one-line-phone-number="FRA +33"
        >
          France +33
        </option>
        <option
          value="594"
          data-country-iso="guf"
          data-country-name="French Guiana"
          data-one-line-phone-number="GUF +594"
        >
          French Guiana +594
        </option>
        <option
          value="689"
          data-country-iso="pyf"
          data-country-name="French Polynesia"
          data-one-line-phone-number="PYF +689"
        >
          French Polynesia +689
        </option>
        <option
          value="241"
          data-country-iso="gab"
          data-country-name="Gabon"
          data-one-line-phone-number="GAB +241"
        >
          Gabon +241
        </option>
        <option
          value="220"
          data-country-iso="gmb"
          data-country-name="Gambia"
          data-one-line-phone-number="GMB +220"
        >
          Gambia +220
        </option>
        <option
          value="995"
          data-country-iso="geo"
          data-country-name="Georgia"
          data-one-line-phone-number="GEO +995"
        >
          Georgia +995
        </option>
        <option
          value="49"
          data-country-iso="deu"
          data-country-name="Germany"
          data-one-line-phone-number="DEU +49"
        >
          Germany +49
        </option>
        <option
          value="233"
          data-country-iso="gha"
          data-country-name="Ghana"
          data-one-line-phone-number="GHA +233"
        >
          Ghana +233
        </option>
        <option
          value="350"
          data-country-iso="gib"
          data-country-name="Gibraltar"
          data-one-line-phone-number="GIB +350"
        >
          Gibraltar +350
        </option>
        <option
          value="30"
          data-country-iso="grc"
          data-country-name="Greece"
          data-one-line-phone-number="GRC +30"
        >
          Greece +30
        </option>
        <option
          value="299"
          data-country-iso="grl"
          data-country-name="Greenland"
          data-one-line-phone-number="GRL +299"
        >
          Greenland +299
        </option>
        <option
          value="1"
          data-country-iso="grd"
          data-country-name="Grenada"
          data-one-line-phone-number="GRD +1"
        >
          Grenada +1
        </option>
        <option
          value="590"
          data-country-iso="glp"
          data-country-name="Guadeloupe"
          data-one-line-phone-number="GLP +590"
        >
          Guadeloupe +590
        </option>
        <option
          value="1"
          data-country-iso="gum"
          data-country-name="Guam"
          data-one-line-phone-number="GUM +1"
        >
          Guam +1
        </option>
        <option
          value="502"
          data-country-iso="gtm"
          data-country-name="Guatemala"
          data-one-line-phone-number="GTM +502"
        >
          Guatemala +502
        </option>
        <option
          value="224"
          data-country-iso="gin"
          data-country-name="Guinea"
          data-one-line-phone-number="GIN +224"
        >
          Guinea +224
        </option>
        <option
          value="245"
          data-country-iso="gnb"
          data-country-name="Guinea-Bissau"
          data-one-line-phone-number="GNB +245"
        >
          Guinea-Bissau +245
        </option>
        <option
          value="592"
          data-country-iso="guy"
          data-country-name="Guyana"
          data-one-line-phone-number="GUY +592"
        >
          Guyana +592
        </option>
        <option
          value="509"
          data-country-iso="hti"
          data-country-name="Haiti"
          data-one-line-phone-number="HTI +509"
        >
          Haiti +509
        </option>
        <option
          value="504"
          data-country-iso="hnd"
          data-country-name="Honduras"
          data-one-line-phone-number="HND +504"
        >
          Honduras +504
        </option>
        <option
          value="852"
          data-country-iso="hkg"
          data-country-name="Hong Kong SAR"
          data-one-line-phone-number="HKG +852"
        >
          Hong Kong SAR +852
        </option>
        <option
          value="36"
          data-country-iso="hun"
          data-country-name="Hungary"
          data-one-line-phone-number="HUN +36"
        >
          Hungary +36
        </option>
        <option
          value="354"
          data-country-iso="isl"
          data-country-name="Iceland"
          data-one-line-phone-number="ISL +354"
        >
          Iceland +354
        </option>
        <option
          value="91"
          data-country-iso="ind"
          data-country-name="India"
          data-one-line-phone-number="IND +91"
        >
          India +91
        </option>
        <option
          value="62"
          data-country-iso="idn"
          data-country-name="Indonesia"
          data-one-line-phone-number="IDN +62"
        >
          Indonesia +62
        </option>
        <option
          value="98"
          data-country-iso="irn"
          data-country-name="Iran"
          data-one-line-phone-number="IRN +98"
        >
          Iran +98
        </option>
        <option
          value="964"
          data-country-iso="irq"
          data-country-name="Iraq"
          data-one-line-phone-number="IRQ +964"
        >
          Iraq +964
        </option>
        <option
          value="353"
          data-country-iso="irl"
          data-country-name="Ireland"
          data-one-line-phone-number="IRL +353"
        >
          Ireland +353
        </option>
        <option
          value="972"
          data-country-iso="isr"
          data-country-name="Israel"
          data-one-line-phone-number="ISR +972"
        >
          Israel +972
        </option>
        <option
          value="39"
          data-country-iso="ita"
          data-country-name="Italy"
          data-one-line-phone-number="ITA +39"
        >
          Italy +39
        </option>
        <option
          value="1"
          data-country-iso="jam"
          data-country-name="Jamaica"
          data-one-line-phone-number="JAM +1"
        >
          Jamaica +1
        </option>
        <option
          value="81"
          data-country-iso="jpn"
          data-country-name="Japan"
          data-one-line-phone-number="JPN +81"
        >
          Japan +81
        </option>
        <option
          value="962"
          data-country-iso="jor"
          data-country-name="Jordan"
          data-one-line-phone-number="JOR +962"
        >
          Jordan +962
        </option>
        <option
          value="7"
          data-country-iso="kaz"
          data-country-name="Kazakhstan"
          data-one-line-phone-number="KAZ +7"
        >
          Kazakhstan +7
        </option>
        <option
          value="254"
          data-country-iso="ken"
          data-country-name="Kenya"
          data-one-line-phone-number="KEN +254"
        >
          Kenya +254
        </option>
        <option
          value="686"
          data-country-iso="kir"
          data-country-name="Kiribati"
          data-one-line-phone-number="KIR +686"
        >
          Kiribati +686
        </option>
        <option
          value="965"
          data-country-iso="kwt"
          data-country-name="Kuwait"
          data-one-line-phone-number="KWT +965"
        >
          Kuwait +965
        </option>
        <option
          value="996"
          data-country-iso="kgz"
          data-country-name="Kyrgyzstan"
          data-one-line-phone-number="KGZ +996"
        >
          Kyrgyzstan +996
        </option>
        <option
          value="856"
          data-country-iso="lao"
          data-country-name="Laos"
          data-one-line-phone-number="LAO +856"
        >
          Laos +856
        </option>
        <option
          value="371"
          data-country-iso="lva"
          data-country-name="Latvia"
          data-one-line-phone-number="LVA +371"
        >
          Latvia +371
        </option>
        <option
          value="961"
          data-country-iso="lbn"
          data-country-name="Lebanon"
          data-one-line-phone-number="LBN +961"
        >
          Lebanon +961
        </option>
        <option
          value="266"
          data-country-iso="lso"
          data-country-name="Lesotho"
          data-one-line-phone-number="LSO +266"
        >
          Lesotho +266
        </option>
        <option
          value="231"
          data-country-iso="lbr"
          data-country-name="Liberia"
          data-one-line-phone-number="LBR +231"
        >
          Liberia +231
        </option>
        <option
          value="218"
          data-country-iso="lby"
          data-country-name="Libya"
          data-one-line-phone-number="LBY +218"
        >
          Libya +218
        </option>
        <option
          value="423"
          data-country-iso="lie"
          data-country-name="Liechtenstein"
          data-one-line-phone-number="LIE +423"
        >
          Liechtenstein +423
        </option>
        <option
          value="370"
          data-country-iso="ltu"
          data-country-name="Lithuania"
          data-one-line-phone-number="LTU +370"
        >
          Lithuania +370
        </option>
        <option
          value="352"
          data-country-iso="lux"
          data-country-name="Luxembourg"
          data-one-line-phone-number="LUX +352"
        >
          Luxembourg +352
        </option>
        <option
          value="853"
          data-country-iso="mac"
          data-country-name="Macau SAR"
          data-one-line-phone-number="MAC +853"
        >
          Macau SAR +853
        </option>
        <option
          value="261"
          data-country-iso="mdg"
          data-country-name="Madagascar"
          data-one-line-phone-number="MDG +261"
        >
          Madagascar +261
        </option>
        <option
          value="265"
          data-country-iso="mwi"
          data-country-name="Malawi"
          data-one-line-phone-number="MWI +265"
        >
          Malawi +265
        </option>
        <option
          value="60"
          data-country-iso="mys"
          data-country-name="Malaysia"
          data-one-line-phone-number="MYS +60"
        >
          Malaysia +60
        </option>
        <option
          value="960"
          data-country-iso="mdv"
          data-country-name="Maldives"
          data-one-line-phone-number="MDV +960"
        >
          Maldives +960
        </option>
        <option
          value="223"
          data-country-iso="mli"
          data-country-name="Mali"
          data-one-line-phone-number="MLI +223"
        >
          Mali +223
        </option>
        <option
          value="356"
          data-country-iso="mlt"
          data-country-name="Malta"
          data-one-line-phone-number="MLT +356"
        >
          Malta +356
        </option>
        <option
          value="692"
          data-country-iso="mhl"
          data-country-name="Marshall Islands"
          data-one-line-phone-number="MHL +692"
        >
          Marshall Islands +692
        </option>
        <option
          value="596"
          data-country-iso="mtq"
          data-country-name="Martinique"
          data-one-line-phone-number="MTQ +596"
        >
          Martinique +596
        </option>
        <option
          value="222"
          data-country-iso="mrt"
          data-country-name="Mauritania"
          data-one-line-phone-number="MRT +222"
        >
          Mauritania +222
        </option>
        <option
          value="230"
          data-country-iso="mus"
          data-country-name="Mauritius"
          data-one-line-phone-number="MUS +230"
        >
          Mauritius +230
        </option>
        <option
          value="269"
          data-country-iso="myt"
          data-country-name="Mayotte"
          data-one-line-phone-number="MYT +269"
        >
          Mayotte +269
        </option>
        <option
          value="52"
          data-country-iso="mex"
          data-country-name="Mexico"
          data-one-line-phone-number="MEX +52"
        >
          Mexico +52
        </option>
        <option
          value="373"
          data-country-iso="mda"
          data-country-name="Moldova"
          data-one-line-phone-number="MDA +373"
        >
          Moldova +373
        </option>
        <option
          value="377"
          data-country-iso="mco"
          data-country-name="Monaco"
          data-one-line-phone-number="MCO +377"
        >
          Monaco +377
        </option>
        <option
          value="976"
          data-country-iso="mng"
          data-country-name="Mongolia"
          data-one-line-phone-number="MNG +976"
        >
          Mongolia +976
        </option>
        <option
          value="382"
          data-country-iso="mne"
          data-country-name="Montenegro"
          data-one-line-phone-number="MNE +382"
        >
          Montenegro +382
        </option>
        <option
          value="1"
          data-country-iso="msr"
          data-country-name="Montserrat"
          data-one-line-phone-number="MSR +1"
        >
          Montserrat +1
        </option>
        <option
          value="212"
          data-country-iso="mar"
          data-country-name="Morocco"
          data-one-line-phone-number="MAR +212"
        >
          Morocco +212
        </option>
        <option
          value="258"
          data-country-iso="moz"
          data-country-name="Mozambique"
          data-one-line-phone-number="MOZ +258"
        >
          Mozambique +258
        </option>
        <option
          value="95"
          data-country-iso="mmr"
          data-country-name="Myanmar"
          data-one-line-phone-number="MMR +95"
        >
          Myanmar +95
        </option>
        <option
          value="264"
          data-country-iso="nam"
          data-country-name="Namibia"
          data-one-line-phone-number="NAM +264"
        >
          Namibia +264
        </option>
        <option
          value="674"
          data-country-iso="nru"
          data-country-name="Nauru"
          data-one-line-phone-number="NRU +674"
        >
          Nauru +674
        </option>
        <option
          value="977"
          data-country-iso="npl"
          data-country-name="Nepal"
          data-one-line-phone-number="NPL +977"
        >
          Nepal +977
        </option>
        <option
          value="31"
          data-country-iso="nld"
          data-country-name="Netherlands"
          data-one-line-phone-number="NLD +31"
        >
          Netherlands +31
        </option>
        <option
          value="599"
          data-country-iso="ant"
          data-country-name="Netherlands Antilles"
          data-one-line-phone-number="ANT +599"
        >
          Netherlands Antilles +599
        </option>
        <option
          value="687"
          data-country-iso="ncl"
          data-country-name="New Caledonia"
          data-one-line-phone-number="NCL +687"
        >
          New Caledonia +687
        </option>
        <option
          value="64"
          data-country-iso="nzl"
          data-country-name="New Zealand"
          data-one-line-phone-number="NZL +64"
        >
          New Zealand +64
        </option>
        <option
          value="505"
          data-country-iso="nic"
          data-country-name="Nicaragua"
          data-one-line-phone-number="NIC +505"
        >
          Nicaragua +505
        </option>
        <option
          value="227"
          data-country-iso="ner"
          data-country-name="Niger"
          data-one-line-phone-number="NER +227"
        >
          Niger +227
        </option>
        <option
          value="234"
          data-country-iso="nga"
          data-country-name="Nigeria"
          data-one-line-phone-number="NGA +234"
        >
          Nigeria +234
        </option>
        <option
          value="683"
          data-country-iso="niu"
          data-country-name="Niue"
          data-one-line-phone-number="NIU +683"
        >
          Niue +683
        </option>
        <option
          value="672"
          data-country-iso="nfk"
          data-country-name="Norfolk Island"
          data-one-line-phone-number="NFK +672"
        >
          Norfolk Island +672
        </option>
        <option
          value="850"
          data-country-iso="prk"
          data-country-name="North Korea"
          data-one-line-phone-number="PRK +850"
        >
          North Korea +850
        </option>
        <option
          value="389"
          data-country-iso="mkd"
          data-country-name="North Macedonia"
          data-one-line-phone-number="MKD +389"
        >
          North Macedonia +389
        </option>
        <option
          value="1"
          data-country-iso="mnp"
          data-country-name="Northern Mariana Islands"
          data-one-line-phone-number="MNP +1"
        >
          Northern Mariana Islands +1
        </option>
        <option
          value="47"
          data-country-iso="nor"
          data-country-name="Norway"
          data-one-line-phone-number="NOR +47"
        >
          Norway +47
        </option>
        <option
          value="968"
          data-country-iso="omn"
          data-country-name="Oman"
          data-one-line-phone-number="OMN +968"
        >
          Oman +968
        </option>
        <option
          value="92"
          data-country-iso="pak"
          data-country-name="Pakistan"
          data-one-line-phone-number="PAK +92"
        >
          Pakistan +92
        </option>
        <option
          value="680"
          data-country-iso="plw"
          data-country-name="Palau"
          data-one-line-phone-number="PLW +680"
        >
          Palau +680
        </option>
        <option
          value="972"
          data-country-iso="pse"
          data-country-name="Palestinian Territories"
          data-one-line-phone-number="PSE +972"
        >
          Palestinian Territories +972
        </option>
        <option
          value="507"
          data-country-iso="pan"
          data-country-name="Panama"
          data-one-line-phone-number="PAN +507"
        >
          Panama +507
        </option>
        <option
          value="675"
          data-country-iso="png"
          data-country-name="Papua New Guinea"
          data-one-line-phone-number="PNG +675"
        >
          Papua New Guinea +675
        </option>
        <option
          value="595"
          data-country-iso="pry"
          data-country-name="Paraguay"
          data-one-line-phone-number="PRY +595"
        >
          Paraguay +595
        </option>
        <option
          value="51"
          data-country-iso="per"
          data-country-name="Peru"
          data-one-line-phone-number="PER +51"
        >
          Peru +51
        </option>
        <option
          value="63"
          data-country-iso="phl"
          data-country-name="Philippines"
          data-one-line-phone-number="PHL +63"
        >
          Philippines +63
        </option>
        <option
          value="48"
          data-country-iso="pol"
          data-country-name="Poland"
          data-one-line-phone-number="POL +48"
        >
          Poland +48
        </option>
        <option
          value="351"
          data-country-iso="prt"
          data-country-name="Portugal"
          data-one-line-phone-number="PRT +351"
        >
          Portugal +351
        </option>
        <option
          value="1"
          data-country-iso="pri"
          data-country-name="Puerto Rico"
          data-one-line-phone-number="PRI +1"
        >
          Puerto Rico +1
        </option>
        <option
          value="974"
          data-country-iso="qat"
          data-country-name="Qatar"
          data-one-line-phone-number="QAT +974"
        >
          Qatar +974
        </option>
        <option
          value="242"
          data-country-iso="cog"
          data-country-name="Republic of the Congo"
          data-one-line-phone-number="COG +242"
        >
          Republic of the Congo +242
        </option>
        <option
          value="262"
          data-country-iso="reu"
          data-country-name="Reunion"
          data-one-line-phone-number="REU +262"
        >
          Reunion +262
        </option>
        <option
          value="40"
          data-country-iso="rou"
          data-country-name="Romania"
          data-one-line-phone-number="ROU +40"
        >
          Romania +40
        </option>
        <option
          value="7"
          data-country-iso="rus"
          data-country-name="Russia"
          data-one-line-phone-number="RUS +7"
        >
          Russia +7
        </option>
        <option
          value="250"
          data-country-iso="rwa"
          data-country-name="Rwanda"
          data-one-line-phone-number="RWA +250"
        >
          Rwanda +250
        </option>
        <option
          value="685"
          data-country-iso="wsm"
          data-country-name="Samoa"
          data-one-line-phone-number="WSM +685"
        >
          Samoa +685
        </option>
        <option
          value="378"
          data-country-iso="smr"
          data-country-name="San Marino"
          data-one-line-phone-number="SMR +378"
        >
          San Marino +378
        </option>
        <option
          value="239"
          data-country-iso="stp"
          data-country-name="Sao Tome and Principe"
          data-one-line-phone-number="STP +239"
        >
          Sao Tome and Principe +239
        </option>
        <option
          value="966"
          data-country-iso="sau"
          data-country-name="Saudi Arabia"
          data-one-line-phone-number="SAU +966"
        >
          Saudi Arabia +966
        </option>
        <option
          value="221"
          data-country-iso="sen"
          data-country-name="Senegal"
          data-one-line-phone-number="SEN +221"
        >
          Senegal +221
        </option>
        <option
          value="381"
          data-country-iso="srb"
          data-country-name="Serbia"
          data-one-line-phone-number="SRB +381"
        >
          Serbia +381
        </option>
        <option
          value="248"
          data-country-iso="syc"
          data-country-name="Seychelles"
          data-one-line-phone-number="SYC +248"
        >
          Seychelles +248
        </option>
        <option
          value="232"
          data-country-iso="sle"
          data-country-name="Sierra Leone"
          data-one-line-phone-number="SLE +232"
        >
          Sierra Leone +232
        </option>
        <option
          value="65"
          data-country-iso="sgp"
          data-country-name="Singapore"
          data-one-line-phone-number="SGP +65"
        >
          Singapore +65
        </option>
        <option
          value="1"
          data-country-iso="sxm"
          data-country-name="Sint Maarten"
          data-one-line-phone-number="SXM +1"
        >
          Sint Maarten +1
        </option>
        <option
          value="421"
          data-country-iso="svk"
          data-country-name="Slovakia"
          data-one-line-phone-number="SVK +421"
        >
          Slovakia +421
        </option>
        <option
          value="386"
          data-country-iso="svn"
          data-country-name="Slovenia"
          data-one-line-phone-number="SVN +386"
        >
          Slovenia +386
        </option>
        <option
          value="677"
          data-country-iso="slb"
          data-country-name="Solomon Islands"
          data-one-line-phone-number="SLB +677"
        >
          Solomon Islands +677
        </option>
        <option
          value="27"
          data-country-iso="zaf"
          data-country-name="South Africa"
          data-one-line-phone-number="ZAF +27"
        >
          South Africa +27
        </option>
        <option
          value="82"
          data-country-iso="kor"
          data-country-name="South Korea"
          data-one-line-phone-number="KOR +82"
        >
          South Korea +82
        </option>
        <option
          value="211"
          data-country-iso="ssd"
          data-country-name="South Sudan"
          data-one-line-phone-number="SSD +211"
        >
          South Sudan +211
        </option>
        <option
          value="34"
          data-country-iso="esp"
          data-country-name="Spain"
          data-one-line-phone-number="ESP +34"
        >
          Spain +34
        </option>
        <option
          value="94"
          data-country-iso="lka"
          data-country-name="Sri Lanka"
          data-one-line-phone-number="LKA +94"
        >
          Sri Lanka +94
        </option>
        <option
          value="290"
          data-country-iso="shn"
          data-country-name="St. Helena"
          data-one-line-phone-number="SHN +290"
        >
          St. Helena +290
        </option>
        <option
          value="1"
          data-country-iso="kna"
          data-country-name="St. Kitts and Nevis"
          data-one-line-phone-number="KNA +1"
        >
          St. Kitts and Nevis +1
        </option>
        <option
          value="1"
          data-country-iso="lca"
          data-country-name="St. Lucia"
          data-one-line-phone-number="LCA +1"
        >
          St. Lucia +1
        </option>
        <option
          value="508"
          data-country-iso="spm"
          data-country-name="St. Pierre and Miquelon"
          data-one-line-phone-number="SPM +508"
        >
          St. Pierre and Miquelon +508
        </option>
        <option
          value="1"
          data-country-iso="vct"
          data-country-name="St. Vincent and the Grenadines"
          data-one-line-phone-number="VCT +1"
        >
          St. Vincent and the Grenadines +1
        </option>
        <option
          value="249"
          data-country-iso="sdn"
          data-country-name="Sudan"
          data-one-line-phone-number="SDN +249"
        >
          Sudan +249
        </option>
        <option
          value="597"
          data-country-iso="sur"
          data-country-name="Suriname"
          data-one-line-phone-number="SUR +597"
        >
          Suriname +597
        </option>
        <option
          value="46"
          data-country-iso="swe"
          data-country-name="Sweden"
          data-one-line-phone-number="SWE +46"
        >
          Sweden +46
        </option>
        <option
          value="41"
          data-country-iso="che"
          data-country-name="Switzerland"
          data-one-line-phone-number="CHE +41"
        >
          Switzerland +41
        </option>
        <option
          value="963"
          data-country-iso="syr"
          data-country-name="Syria"
          data-one-line-phone-number="SYR +963"
        >
          Syria +963
        </option>
        <option
          value="886"
          data-country-iso="twn"
          data-country-name="Taiwan"
          data-one-line-phone-number="TWN +886"
        >
          Taiwan +886
        </option>
        <option
          value="992"
          data-country-iso="tjk"
          data-country-name="Tajikistan"
          data-one-line-phone-number="TJK +992"
        >
          Tajikistan +992
        </option>
        <option
          value="255"
          data-country-iso="tza"
          data-country-name="Tanzania"
          data-one-line-phone-number="TZA +255"
        >
          Tanzania +255
        </option>
        <option
          value="66"
          data-country-iso="tha"
          data-country-name="Thailand"
          data-one-line-phone-number="THA +66"
        >
          Thailand +66
        </option>
        <option
          value="228"
          data-country-iso="tgo"
          data-country-name="Togo"
          data-one-line-phone-number="TGO +228"
        >
          Togo +228
        </option>
        <option
          value="690"
          data-country-iso="tkl"
          data-country-name="Tokelau"
          data-one-line-phone-number="TKL +690"
        >
          Tokelau +690
        </option>
        <option
          value="676"
          data-country-iso="ton"
          data-country-name="Tonga"
          data-one-line-phone-number="TON +676"
        >
          Tonga +676
        </option>
        <option
          value="1"
          data-country-iso="tto"
          data-country-name="Trinidad and Tobago"
          data-one-line-phone-number="TTO +1"
        >
          Trinidad and Tobago +1
        </option>
        <option
          value="216"
          data-country-iso="tun"
          data-country-name="Tunisia"
          data-one-line-phone-number="TUN +216"
        >
          Tunisia +216
        </option>
        <option
          value="90"
          data-country-iso="tur"
          data-country-name="Turkey"
          data-one-line-phone-number="TUR +90"
        >
          Turkey +90
        </option>
        <option
          value="993"
          data-country-iso="tkm"
          data-country-name="Turkmenistan"
          data-one-line-phone-number="TKM +993"
        >
          Turkmenistan +993
        </option>
        <option
          value="1"
          data-country-iso="tca"
          data-country-name="Turks and Caicos"
          data-one-line-phone-number="TCA +1"
        >
          Turks and Caicos +1
        </option>
        <option
          value="688"
          data-country-iso="tuv"
          data-country-name="Tuvalu"
          data-one-line-phone-number="TUV +688"
        >
          Tuvalu +688
        </option>
        <option
          value="1"
          data-country-iso="vir"
          data-country-name="U.S. Virgin Islands"
          data-one-line-phone-number="VIR +1"
        >
          U.S. Virgin Islands +1
        </option>
        <option
          value="256"
          data-country-iso="uga"
          data-country-name="Uganda"
          data-one-line-phone-number="UGA +256"
        >
          Uganda +256
        </option>
        <option
          value="380"
          data-country-iso="ukr"
          data-country-name="Ukraine"
          data-one-line-phone-number="UKR +380"
        >
          Ukraine +380
        </option>
        <option
          value="971"
          data-country-iso="are"
          data-country-name="United Arab Emirates"
          data-one-line-phone-number="ARE +971"
        >
          United Arab Emirates +971
        </option>
        <option
          value="44"
          data-country-iso="gbr"
          data-country-name="United Kingdom"
          data-one-line-phone-number="GBR +44"
        >
          United Kingdom +44
        </option>
        <option
          value="1"
          selected="selected"
          data-country-iso="usa"
          data-country-name="United States of America"
          data-one-line-phone-number="USA +1"
        >
          United States of America +1
        </option>
        <option
          value="598"
          data-country-iso="ury"
          data-country-name="Uruguay"
          data-one-line-phone-number="URY +598"
        >
          Uruguay +598
        </option>
        <option
          value="998"
          data-country-iso="uzb"
          data-country-name="Uzbekistan"
          data-one-line-phone-number="UZB +998"
        >
          Uzbekistan +998
        </option>
        <option
          value="678"
          data-country-iso="vut"
          data-country-name="Vanuatu"
          data-one-line-phone-number="VUT +678"
        >
          Vanuatu +678
        </option>
        <option
          value="39"
          data-country-iso="vat"
          data-country-name="Vatican City"
          data-one-line-phone-number="VAT +39"
        >
          Vatican City +39
        </option>
        <option
          value="58"
          data-country-iso="ven"
          data-country-name="Venezuela"
          data-one-line-phone-number="VEN +58"
        >
          Venezuela +58
        </option>
        <option
          value="84"
          data-country-iso="vnm"
          data-country-name="Vietnam"
          data-one-line-phone-number="VNM +84"
        >
          Vietnam +84
        </option>
        <option
          value="681"
          data-country-iso="wlf"
          data-country-name="Wallis and Futuna"
          data-one-line-phone-number="WLF +681"
        >
          Wallis and Futuna +681
        </option>
        <option
          value="967"
          data-country-iso="yem"
          data-country-name="Yemen"
          data-one-line-phone-number="YEM +967"
        >
          Yemen +967
        </option>
        <option
          value="260"
          data-country-iso="zmb"
          data-country-name="Zambia"
          data-one-line-phone-number="ZMB +260"
        >
          Zambia +260
        </option>
        <option
          value="263"
          data-country-iso="zwe"
          data-country-name="Zimbabwe"
          data-one-line-phone-number="ZWE +263"
        >
          Zimbabwe +263
        </option>
      </select>
    </>
  );
}
